$(document).ready(function () {
  $('.explore-collection .glide').each(function () {
    const $glide = $(this);
    const sectionId = $glide.data('section-id');
    const $controls = $(`[data-section-controls="${sectionId}"]`);

    if ($controls.length) {
      const glideInstance = new Glide($glide[0], {
        type: 'carousel',
        perView: 4,
        gap: 27,
        breakpoints: {
          768: {
            perView: 1,
            gap: 10,
            peek: {
              before: 0,
              after: 70,
            },
          },
          1200: {
            perView: 2,
          }
        }
      });

      glideInstance.mount();

      window.dispatchEvent(new Event('resize'));

      $controls.find('.glide__arrow--left').on('click', function () {
        glideInstance.go('<');
      });

      $controls.find('.glide__arrow--right').on('click', function () {
        glideInstance.go('>');
      });
    }
  });
});
